/**
* Process Steps JS
* -----------------------------------------------------------------------------
*
* All the JS for the Process Steps component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'process-steps',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.process-steps' ).each( function( key, component ) {
        const $component = $( component );
        const initialSlide = $component.find( '.timed-slider' ).find( '.slide button[data-toggle-is-active]' ).closest( '.slide' );
        initialSlide.addClass( 'is-active' );
        const initialSlideTop = $( initialSlide ).position().top;

        let slideTimers;
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 75%',
            end: 'bottom 75%',
            scrub: 0,
            onEnter: ( x, y, z ) => {
              $component.find( '.circle-progress' ).addClass( 'is-timed' );
              $component.find( '.tracker' ).css( 'top', initialSlideTop ).addClass( 'is-loaded' );
              // set the timer to autoplay
              slideTimers = setInterval( function() {
                getNextSlide();
              }, 3000 );
            },
            // markers: true,
          },
        } );

        // Set description heights
        let maxSlideHeight = 0;
        $component.find( '.timed-slider .slide' ).each( function( slideKey, slide ) {
          if ( $( slide ).find( '.description' ).height() > maxSlideHeight ) {
            maxSlideHeight = $( slide ).find( '.description' ).height();
          }
        } );
        $component.find( '.timed-slider .slide .description' ).height( maxSlideHeight );
        $component.find( '.timed-slider .dotted-line' ).height( $component.find( '.timed-slider .dotted-line' ).height() - $component.find( '.timed-slider .slide' ).last().outerHeight() );

        // on next slide click
        $component.find( '.timed-slider button' ).on( 'click', function( e ) {
          restartCircleProgress();

          // if the button was actually clicked, not just triggered
          if ( e.originalEvent ) {
            clearInterval( slideTimers );
            slideTimers = false;
          }

          // if the timer isn't running, restart it
          if ( !slideTimers ) {
            slideTimers = setInterval( function() {
              getNextSlide();
            }, 3000 );
          }

          // set the classes on the slides
          $( this ).closest( '.slide' ).prevAll().removeClass( 'is-tracked' ).addClass( 'is-active' );
          $( this ).closest( '.slide' ).addClass( 'is-active is-tracked' );
          $( this ).closest( '.slide' ).nextAll().removeClass( 'is-active is-tracked' );

          // set the classes on the images
          let stepImg = $component.find( '.step-images img[data-step="' + $( this ).closest( '.slide' ).attr( 'data-step' ) + '"]' );

          if ( window.innerWidth < 1024 ) {
            stepImg = $component.find( '.step-images .image-wrapper[data-step="' + $( this ).closest( '.slide' ).attr( 'data-step' ) + '"]' );
          }

          $component.find( '.step-images img, .step-images .image-wrapper' ).not( stepImg ).removeClass( 'is-tracked' );
          $( stepImg ).addClass( 'is-tracked' );

          // move the tracker
          const slideTop = $( this ).closest( '.slide' ).position().top;
          $component.find( '.timed-slider .tracker' ).css( 'top', slideTop );
        } );

        // set new slide
        function getNextSlide() {
          if ( $component.find( '.timed-slider .slide.is-tracked' ).next().length ) {
            $component.find( '.timed-slider .slide.is-tracked' ).next().find( 'button' ).trigger( 'click' );
          } else {
            clearInterval( slideTimers );
            slideTimers = false;
          }
        }

        // restart animation on circle progress bar
        function restartCircleProgress() {
          const progressCircle = $component.find( '.timed-slider .circle-progress' )[0].outerHTML;
          $component.find( '.timed-slider .circle-progress' ).remove();
          $component.find( '.timed-slider .tracker' ).append( progressCircle );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'process-steps', COMPONENT );
} )( app );
